module.exports = __webpack_public_path__ + "img/BMGHardwareSustainedCompressionInducesIntimateAlignmentBold.91749f47.jpg";